import Dialogue from './Dialogue';

export default Dialogue;
